import { render, staticRenderFns } from "./SimpleNameElement.vue?vue&type=template&id=2506554c&"
import script from "./SimpleNameElement.vue?vue&type=script&lang=js&"
export * from "./SimpleNameElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports